import PropTypes from 'prop-types';

function Base({ size, direction }) {
  return (
    <div
      style={{
        width: direction === 'vertical' ? 0 : size,
        height: direction === 'vertical' ? size : 0,
      }}
    />
  );
}

function Vertical({ size = 10 }) {
  return <Base size={size} direction="vertical" />;
}

function Horizontal({ size = 10 }) {
  return <Base size={size} direction="horizontal" />;
}

export const Spacer = {
  vertical: Vertical,
  horizontal: Horizontal,
};

Vertical.propTypes = Horizontal.propTypes = {
  size: PropTypes.number,
};
